import { action, flow, makeObservable, observable } from 'mobx';
import { GlobalStore } from '@roc/feature-app-core';
import { DocumentStore } from '@roc/feature-documents';
import { LoanStore } from '@roc/feature-loans';
import { FormStore } from '@roc/feature-app-core';
import { format, isValid, parse } from 'date-fns';
import { DocumentName } from '../../constants';
import { shouldBeAbleToSubmitSpecificForm } from '../../utils/documentForms';
import { flatten, formatDate } from '@roc/feature-utils';
import { InspectionPhotosService } from 'libs/feature-inspections/src/services/inspectionPhotosService';
import { PhotoGalleryImage } from '@roc/ui';
import { PointOfContactV2Store } from '@roc/feature-draws';

export const requestedClosingDateForm = {
  fields: {
    date: {
      value: null,
      error: null,
      rule: 'required',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export class TakePropertyPhotosStore {
  private documentStore: DocumentStore;
  globalStore: GlobalStore;
  pointOfContactV2Store: PointOfContactV2Store;

  constructor(
    loanStore: LoanStore,
    documentStore: DocumentStore,
    globalStore: GlobalStore
  ) {
    this.pointOfContactV2Store = new PointOfContactV2Store(globalStore);
  }

  closeModal() {
    return this.documentStore.documentFormStore.setCurrentForm(null);
  }
}
